import { queryGraphQL,mutateGraphQL } from 'common/util/query';
import { toMutation, toQuery, nodeWithArgs, node } from 'common/util/queryHelper';
import { addApplicationMessage } from 'common/actions/applicationMessagesActions';
import { binderInstitutionIdSelector } from 'common/selectors';
import {
    retrieveStudyAuditLogData,
} from './studyAuditLog';

export const LOAD_STUDY_SIGNATURE_EXPECTATIONS = 'LOAD_STUDY_SIGNATURE_EXPECTATIONS';
export const LOAD_STUDY_SIGNATURES = 'LOAD_STUDY_SIGNATURES';
export const SATISFY_SIGNATURE_EXPECTATIONS = 'SATISFY_SIGNATURE_EXPECTATIONS';

export function loadSignatureExpectations(binderId) {
    return (dispatch, getState) => {
        const state = getState();
        const institutionId = binderInstitutionIdSelector(state);
        const query = nodeWithArgs('doaSignatureExpectations', {
            binderId,
            institutionId,
        }, [
            'delegationId',
            'signatureType',
            'testament',
            node('user', [
                'id',
                'displayName',
                'emailAddress',
            ]),
            'signedAt',
        ]);

        return queryGraphQL(toQuery(query)).then(results => {
            if (results && results.errors) {
                dispatch(addApplicationMessage('error', 'Failed to retrieve signature expectations'));
            } else {
                dispatch({
                    type: LOAD_STUDY_SIGNATURE_EXPECTATIONS,
                    payload: results.data.doaSignatureExpectations,
                });
            }
        });
    };
}

export function loadStudySignatures(binderId) {
    return (dispatch, getState) => {
        const state = getState();
        const institutionId = binderInstitutionIdSelector(state);
        dispatch({
            type: 'LOADING_STUDY_SIGNATURES',
            payload: null,
        });
        const query = nodeWithArgs('studySignatures', {
            binderId,
            institutionId,
        }, [
            'id',
            'delegationId',
            'signatureType',
            node('signature', [
                'id',
                node('user',[
                    'id',
                    'displayName',
                    'emailAddress',
                ]),
                'statement',
                'createdAt',
            ]),
        ]);

        return queryGraphQL(toQuery(query)).then(results => {
            if (results && results.errors) {
                dispatch(addApplicationMessage('error', 'Failed to retrieve signatures for delegation log'));
            } else {
                dispatch({
                    type: LOAD_STUDY_SIGNATURES,
                    payload: results.data.studySignatures,
                });
            }
        });
    };
}

export function satisfySignatureExpectations(binderId, userId, signature, signatureExpectations) {
    return(dispatch, getState) => {
        const state = getState();
        const institutionId = binderInstitutionIdSelector(state);
        const query = nodeWithArgs('satisfySignatureExpectations', {
            institutionId,
            binderId,
            userId,
            signature,
            signatureExpectations,
        }, [
            'id',
            'delegationId',
            'signatureType',
            node('signature', [
                'userId',
                node('user',[ // needed here to allow the user to export without refreshing first
                    'id',
                    'displayName',
                    'emailAddress',
                ]),
                'statement',
                'createdAt',
            ]),
        ]);
        return mutateGraphQL(toMutation(query)).then(results => {
            if (results && results.errors) {
                dispatch(addApplicationMessage('error', 'Failed to sign delegations'));
            } else {
                dispatch({
                    type: SATISFY_SIGNATURE_EXPECTATIONS,
                    payload: results.data.satisfySignatureExpectations,
                });
                dispatch(loadSignatureExpectations(binderId));
                dispatch(loadStudySignatures(binderId));
                dispatch(retrieveStudyAuditLogData(binderId));
                dispatch(addApplicationMessage('success', 'Successfully signed delegations'));
            }
        });
    };
}